import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import Panel from '@/components/Panel';
import NetsConnection from './netsConnection';
import { getPanelMaxWidth, getPanelWidth, getPanelMaxHeight } from '@/services/helper/panelSizeHelper';
import './index.css';

class netsConnectionPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      maxWidth: 800,
      maxHeight: 800,
      contentWidth: 600,
      contentHeight: 500,
      drawStatus: false,
      nets: []
    };
    this.dialogRoot = document.getElementById('root');
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  resize = () => {
    const offset = this.dialogRoot.getBoundingClientRect();
    const contentRoot = document.getElementById('cascade-net-connection-content') || {}
    const { drawStatus } = this.state;
    this.setState({
      maxWidth: getPanelMaxWidth(offset, 800),
      maxHeight: getPanelMaxHeight(offset, 800),
      contentWidth: contentRoot.scrollWidth || 600,
      contentHeight: contentRoot.scrollHeight || 500,
      drawStatus: !drawStatus
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize);
    this.resize();
    const { netsInfo: { nets = [] } } = this.props;
    this.setState({
      nets
    })
  }

  closeModal = () => {
    if (this.netsRef) {
      const { nets, save } = this.netsRef.getNetsAndSave();
      this.props.closeModal(nets, save);
      return;
    }
    this.props.closeModal([], false)
  }

  saveNets = () => {
    if (this.netsRef) {
      const { nets } = this.netsRef.getNetsAndSave();
      this.setState({
        nets
      }, () => {
        this.setState({
          drawStatus: !this.state.drawStatus
        })
      })
    }
  }

  onNetsRef = (ref) => {
    this.netsRef = ref;
  }

  render() {
    const { maxWidth, maxHeight, contentWidth, contentHeight, drawStatus, nets } = this.state;
    const { autoConnection, netsInfo } = this.props;
    const _autoConnection = autoConnection.map(item => item.name)
    const content = (
      <Panel
        className='cascade-power-select-panel'
        title={<div className='cascade-power-select-title'>Connect Nets</div>}
        onCancel={this.closeModal}
        zIndex={2000}
        width={getPanelWidth(maxWidth, { defaultWidth: 800 })}
        height={600}
        maxHeight={maxHeight}
        position='panel-center'
        draggable
        minHeight={500}
        minWidth={800}
        defaultTop={200}
        resizeEnd={this.resize}
      >
        <div className='cascade-position-relative'>
          <NetsConnection {...this.props} netsInfo={{ ...netsInfo, nets }} saveNets={this.saveNets} autoConnection={_autoConnection} contentWidth={contentWidth} contentHeight={contentHeight} onRef={this.onNetsRef} drawStatus={drawStatus} resize={this.resize} />
        </div>
      </Panel>
    )
    return createPortal(content, this.dialogRoot);
  }
};


export default netsConnectionPanel;
